import { render, staticRenderFns } from "./FeedbackDropdownMenu.vue?vue&type=template&id=b8c263c6&scoped=true"
import script from "./FeedbackDropdownMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackDropdownMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FeedbackDropdownMenu.vue?vue&type=style&index=0&id=b8c263c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c263c6",
  null
  
)

export default component.exports